import React, { useEffect, useState } from 'react';
import { BQLink } from '../../../atoms/bqlink';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
// import SvgIcon from '../../../atoms/svg-icon';
import SocialShare from '../global-header/social-share';
import { STRINGS } from '../../../../constants';
import { isMobile } from 'react-device-detect';
import Icon from '@mdi/react';
import {
  mdiAccount,
  mdiChevronRight,
  mdiClose,
  mdiMagnify,
  mdiPower,
  mdiChevronDown,
  mdiChevronUp,
  mdiTelevisionClassic,
  mdiGooglePlay,
  mdiApple,
} from '@mdi/js';
import {
  clickPreferredSourceBadge,
  downloadAppDl,
  accountInteraction,
  signInClick,
  watchLiveInteraction,
} from '../../../../helpers/datalayer-utils';
import { getUserStatus, getUserFirstLetter, parseSubTitle } from '../../../../helpers/utils';
import { getSSORedirectUrl, getSSOLoginUrl } from '../../../../helpers/subscription-helper';

import './drawer-menu.m.css';

export const STORE_LINKS = [
  {
    href: 'https://play.google.com/store/apps/details?id=com.ndtv.ndtvprofit&pcampaignid=web_share',
    alt: 'Play Store',
    img: mdiGooglePlay,
  },
  {
    href: 'https://apps.apple.com/in/app/ndtv-profit/id502359431',
    alt: 'App Store',
    img: mdiApple,
  },
];

const DrawerMenu = ({
  data = [],
  isOpen,
  setIsOpen,
  pageType,
  userData = {},
  logout,
  isBeeps = false,
  hamburgerList = {},
  isSubscriber,
}) => {
  const miscList = hamburgerList?.hamburgMenu_misc;
  const userList = hamburgerList?.hamburgMenu_user || {};
  const [query, setQuery] = useState('');
  const [loginUrl, setLoginUrl] = useState('');
  const [redirectUrl, setRedirectUrl] = useState('');

  // Titles coming from config (fall back to sensible defaults)
  const featuredName = userList?.featuredName || 'Featured';
  const allSectionName = userList?.allSection || 'All Sections';
  const otherName = userList?.otherName || 'Others';

  const featuredList = { title: featuredName, items: [] };
  const otherList = { title: otherName, items: [] };
  const allSectionList = { title: allSectionName, items: [] };

  const groupedByDesc = {};

  (data || []).forEach((item) => {
    const desc = item?.Desc?.trim() || '';

    // 1️⃣ Featured group
    if (desc.toLowerCase() === featuredName?.toLowerCase()) {
      featuredList.items.push(item);
      return;
    }

    // 2️⃣ Other group
    if (!desc || desc === '' || item?.subCategory?.length === 1) {
      otherList.items.push(item);
      return;
    }

    // 3️⃣ Group by Desc (Example: market, business, finance etc.)
    if (!groupedByDesc[desc]) {
      groupedByDesc[desc] = {
        title: desc,
        EmbedCode: item?.EmbedCode || null,
        items: [],
      };
    }

    groupedByDesc[desc].items.push(item);
  });

  // Convert grouped object to array
  Object.values(groupedByDesc).forEach((group) => {
    allSectionList.items.push(group);
  });

  const formattedPageType =
    pageType === 'story-page' ? 'story' : pageType !== 'home-page' ? 'section-page' : pageType;

  const [currentOpenMenu, setCurrentOpenMenu] = useState('');
  const googleBadge = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'google_badge_content'], {}),
  );
  const integrations = useSelector((state) => get(state, ['qt', 'config', 'integrations'], {}));
  const SSO_LOGIN_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'login_url'], null),
  );

  // SSO redirect url (only on client)
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const url = new URL(window.location.href);
    getSSORedirectUrl(url).then((pageUrl) => {
      setRedirectUrl(pageUrl);
    });
  }, []);

  // Build SSO login url when redirectUrl or integrations change
  useEffect(() => {
    // guard required fields
    const clientId = integrations?.sso?.client_id;
    const clientSecret = integrations?.sso?.client_secret;
    if (!clientId || !clientSecret) return;

    getSSOLoginUrl(clientId, clientSecret, redirectUrl, SSO_LOGIN_URL).then((pageUrl) => {
      setLoginUrl(pageUrl);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectUrl, integrations?.sso?.client_id, integrations?.sso?.client_secret, SSO_LOGIN_URL]);

  // Prevent body scroll when drawer open
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleMenuExpand = (menuName) => {
    setCurrentOpenMenu((prev) => (prev === menuName ? '' : menuName));
  };

  // Safely split a section's subCategory into two columns

  const getGrid = (sec = {}) => {
    const items = Array.isArray(sec.items) ? sec.items : [];
    const middle = Math.ceil(items.length / 2);

    return {
      left: items.slice(0, middle),
      right: items.slice(middle),
    };
  };

  const UserInfo = () => {
    return (
      <div styleName="userGreetSection">
        <div styleName="greeting">
          <div styleName={`userInitials ${isSubscriber ? 'premiumUser' : ''}`}>
            <div styleName="whiteCircle">
              <div styleName="innerCircle">
                {getUserFirstLetter(userData?.userProfile) ? (
                  <div styleName="userLetter">{getUserFirstLetter(userData?.userProfile)}</div>
                ) : (
                  <div styleName="logo">
                    <Icon path={mdiAccount} size="18px" color="var(--grey-border)" />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div styleName="nameCtx">
            <div styleName="name">
              {userData?.userProfile?.fullName ? (
                <div
                  styleName="userName"
                  onClick={() =>
                    accountInteraction(userData, pageType, 'hamburger', 'view profile')
                  }
                >
                  <BQLink href="/my-account/profile?src=hamburger">
                    {userData?.userProfile?.fullName}
                  </BQLink>
                </div>
              ) : (
                <div>{STRINGS?.DEFAULT_USER_NAME}</div>
              )}
            </div>

            {!!userData?.userProfile && !!userData?.userProfile.userId ? (
              <div styleName={`subTag ${isSubscriber ? 'premiumTag' : 'basicTag'}`}>
                {isSubscriber ? (
                  <span>{STRINGS?.PREMIUM_USER}</span>
                ) : (
                  <span>{STRINGS?.BASIC_USER}</span>
                )}
              </div>
            ) : (
              <>
                {!isBeeps && (
                  <div
                    onClick={() => signInClick(userData, pageType, STRINGS?.SIGN_IN, 'hamburger')}
                  >
                    <BQLink href={loginUrl} target="_self" styleName="signIn">
                      {STRINGS?.SIGN_IN}
                      <Icon path={mdiChevronRight} size="18px" color="var(--mine-shaft)" />
                    </BQLink>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  // GA function
  const searchDataLayer = (name, userDataObj, select_type) => {
    const baseData = {
      event: 'search_term_entered',
      search_term: name || 'NA',
      select_type: select_type || 'enter',
      page_title: 'NA',
      page_template: 'search-bar',
      user_id: userDataObj?.userProfile?.userId || 'NA',
      user_status: getUserStatus(),
      login_type: userDataObj?.isLoggedIn ? 'logged-in' : 'logged-out',
      language_hit: 'english',
      Platform: isMobile ? 'mobile' : 'desktop',
      SiteName: 'www.ndtvprofit.com',
    };
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push(baseData);
    }
  };

  const handleSearchSubmit = () => {
    const text = query.trim();
    if (!text) return;
    searchDataLayer(text, userData, 'enter');
    setQuery('');
    if (typeof window !== 'undefined') {
      window.location.href = `/search?q=${encodeURIComponent(text)}`;
    }
  };

  const handleClickItem = (menu, formattedPageTypeArg) => {
    const baseData = {
      event: 'navigation_interaction',
      cta_text: menu?.Title || menu?.title || 'NA',
      select_type: 'hamburger',
      page_template: formattedPageTypeArg || 'NA',
      user_id: userData?.userProfile?.userId || 'NA',
      user_status: getUserStatus(),
      login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
      language_hit: 'english',
      Platform: isMobile ? 'mobile' : 'desktop',
      SiteName: 'www.ndtvprofit.com',
    };

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push(baseData);
    }
  };

  const getItemHref = (item) => {
    const isLoggedIn = !!userData?.userProfile?.userId;
    if (item?.userOnly) {
      return isLoggedIn ? item?.Link : loginUrl;
    }
    return item?.Link;
  };

  const onItemClick = (item) => {
    const isLoggedIn = !!userData?.userProfile?.userId;
    if (item?.userOnly && !isLoggedIn) {
      return signInClick(userData, pageType, STRINGS?.SIGN_IN, 'hamburger');
    }
    return handleClickItem(item, formattedPageType);
  };

  return (
    <>
      <div styleName={isOpen ? 'drawerOverlay show' : 'drawerOverlay'} />
      <div styleName={isOpen ? 'drawerMenu open' : 'drawerMenu'}>
        <div styleName={isBeeps ? 'drawer darkMode' : 'drawer'}>
          <div styleName="socialSection">
            <div styleName="liveTvSection">
              <div styleName="name">{STRINGS?.LIVE_TV}</div>
              <div
                styleName="liveTV"
                onClick={() => watchLiveInteraction(userData, pageType, 'hamburger')}
              >
                <Icon path={mdiTelevisionClassic} size="16px" color="#1d262f" />
              </div>
            </div>

            <div styleName="appSection">
              <div styleName="name">{STRINGS?.APP}</div>
              {Array.isArray(STORE_LINKS) &&
                STORE_LINKS.map((store, idx) => (
                  <div
                    key={`store-${idx}`}
                    onClick={() =>
                      downloadAppDl(store.alt, userData, formattedPageType, 'hamburger')
                    }
                  >
                    <BQLink href={store.href} target="_blank" styleName="icon">
                      <Icon path={store.img} size="16px" color="#1d262f" />
                    </BQLink>
                  </div>
                ))}
            </div>
            <div styleName="name">{STRINGS?.SOCIAL}</div>
            <SocialShare postion="vertical" name="drawer" />
            {userData?.isLoggedIn && !isBeeps && (
              <div
                onClick={() => accountInteraction(userData, pageType, 'hamburger', 'logout')}
                styleName="logoutSection"
              >
                <div onClick={logout} styleName="logoutBtn">
                  <Icon path={mdiPower} size="16px" color="#1d262f" />
                </div>
              </div>
            )}
          </div>

          <div styleName="menuContent">
            <div styleName="menuSection">
              {/* LOGO AND SEARCH SECTIONS */}
              <div styleName="logoSearchSection">
                <div styleName="siteLogo">
                  <img
                    src={
                      isBeeps
                        ? '/images/NDTV-Profit-logo-darkmode.png'
                        : '/icons/ndtv_profit_black.svg'
                    }
                    width="160px"
                    height="28px"
                    alt="logo"
                  />
                  <div onClick={() => setIsOpen(false)} styleName="closeBtn">
                    <Icon path={mdiClose} size="16px" color={isBeeps ? '#878787' : '#000000'} />
                  </div>
                </div>
              </div>

              {/* SEARCH USER AND LIST SECTIONS */}
              <div styleName="userAndListSection">
                <div styleName="searchWrapper">
                  <Icon path={mdiMagnify} size="16px" color={isBeeps ? '#878787' : '#000000'} />
                  <input
                    type="text"
                    placeholder="Search NDTV Profit"
                    styleName="input"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSearchSubmit();
                      }
                    }}
                    onFocus={(e) => e.target.select()}
                  />
                  <div onClick={() => setQuery('')} styleName="closeBtn">
                    <Icon path={mdiClose} size="14px" color={isBeeps ? '#878787' : '#1d262f'} />
                  </div>
                </div>

                <UserInfo />

                {/* ACCOUNT (userList from config) */}
                {Array.isArray(userList?.items) && userList.items.length > 0 && (
                  <div styleName="block">
                    {userList?.title && <div styleName="heading">{userList.title}</div>}
                    <div styleName="gridTwo">
                      {userList.items.map((item, idx) => {
                        const { text } = parseSubTitle(item?.SubTitle);
                        return (
                          <div
                            key={`user-item-${idx}`}
                            styleName="item"
                            onClick={() => onItemClick(item)}
                          >
                            <BQLink
                              styleName="link"
                              href={getItemHref(item)}
                              target={item?.Target}
                              rel={item?.Rel}
                              style={{
                                '--dynamic-color': isBeeps
                                  ? '#ffffff'
                                  : item?.EmbedCode || 'var(--mine-shaft)',
                              }}
                            >
                              {item?.Title}
                              {text && <span styleName="tag">{text}</span>}
                            </BQLink>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* FEATURED */}
                {Array.isArray(featuredList.items) && featuredList.items.length > 0 && (
                  <div styleName="block">
                    {featuredList?.title && <div styleName="heading">{featuredList.title}</div>}
                    <div styleName="gridTwo">
                      {featuredList.items.map((item, idx) => {
                        const { text } = parseSubTitle(item?.SubTitle);
                        return (
                          <div
                            key={`featured-${idx}`}
                            styleName="item"
                            onClick={() => handleClickItem(item, formattedPageType)}
                          >
                            <BQLink
                              styleName="link"
                              href={item?.Link}
                              style={{
                                '--dynamic-color': isBeeps
                                  ? '#ffffff'
                                  : item?.EmbedCode || 'var(--mine-shaft)',
                              }}
                              target={item?.target}
                            >
                              {item.Title}
                              {item.Title?.toLowerCase() === 'live tv' && (
                                <div styleName="liveDot">
                                  <span styleName="circle" />
                                </div>
                              )}
                              {text && <span styleName="tag">{text}</span>}
                            </BQLink>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* ALL SECTIONS (accordion with subCategory splitted into two columns) */}
                {Array.isArray(allSectionList.items) && allSectionList.items.length > 0 && (
                  <div styleName="block">
                    {/* {allSectionList?.title && <div styleName="heading">{allSectionList.title}</div>} */}
                    {allSectionList?.items?.map((sec, idx) => {
                      const { left, right } = getGrid(sec);
                      const isOpen = currentOpenMenu === sec?.title;
                      return (
                        <div key={`all-sec-${idx}`} styleName="sectionBlock">
                          <div
                            styleName="sectionHeader"
                            onClick={() => handleMenuExpand(sec?.title)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') handleMenuExpand(sec?.title);
                            }}
                          >
                            <div
                              style={{
                                '--dynamic-color': isBeeps
                                  ? '#ffffff'
                                  : sec?.EmbedCode || 'var(--mine-shaft)',
                              }}
                              styleName="sectionTitle"
                            >
                              {sec?.title}
                            </div>
                            <div styleName="icon">
                              <Icon
                                path={isOpen ? mdiChevronUp : mdiChevronDown}
                                size="20px"
                                color={isBeeps ? '#878787' : '#000000'}
                              />
                            </div>
                          </div>

                          <div styleName={`sectionBody ${isOpen ? 'open' : ''}`}>
                            <div styleName="gridTwo">
                              {left.map((item, i) => {
                                const { text } = parseSubTitle(item?.SubTitle);
                                return (
                                  <div
                                    key={`all-${idx}-left-${i}`}
                                    styleName="item"
                                    onClick={() => handleClickItem(item, formattedPageType)}
                                  >
                                    <BQLink
                                      styleName="link"
                                      href={item?.Link}
                                      style={{
                                        '--dynamic-color': isBeeps
                                          ? '#ffffff'
                                          : item?.EmbedCode || 'var(--mine-shaft)',
                                      }}
                                      target={item?.target}
                                    >
                                      {item?.Title}
                                      {text && <span styleName="tag">{text}</span>}
                                    </BQLink>
                                  </div>
                                );
                              })}

                              {right.map((subItem, i) => {
                                const { text } = parseSubTitle(subItem?.SubTitle);
                                return (
                                  <div
                                    key={`all-${idx}-right-${i}`}
                                    styleName="item"
                                    onClick={() => handleClickItem(subItem, formattedPageType)}
                                  >
                                    <BQLink
                                      styleName="link"
                                      href={subItem?.Link}
                                      style={{
                                        '--dynamic-color': isBeeps
                                          ? '#ffffff'
                                          : subItem?.EmbedCode || 'var(--mine-shaft)',
                                      }}
                                      target={subItem?.target}
                                    >
                                      {subItem?.Title}
                                      {text && <span styleName="tag">{text}</span>}
                                    </BQLink>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* OTHER LIST */}
                {Array.isArray(otherList.items) && otherList.items.length > 0 && (
                  <div styleName="block">
                    {otherList?.title && <div styleName="heading">{otherList.title}</div>}
                    <div styleName="gridTwo">
                      {otherList.items.map((item, idx) => {
                        const { text } = parseSubTitle(item?.SubTitle);
                        return (
                          <div
                            key={`other-${idx}`}
                            styleName="item"
                            onClick={() => handleClickItem(item, formattedPageType)}
                          >
                            <BQLink
                              styleName="link"
                              href={item?.Link}
                              style={{
                                '--dynamic-color': isBeeps
                                  ? '#ffffff'
                                  : item?.EmbedCode || 'var(--mine-shaft)',
                              }}
                              target={item?.target}
                            >
                              {item.Title}
                              {item.Title?.toLowerCase() === 'live tv' && (
                                <div styleName="liveDot">
                                  <span styleName="circle" />
                                </div>
                              )}
                              {text && <span styleName="tag">{text}</span>}
                            </BQLink>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* MISC */}
                {miscList && (
                  <div styleName="block">
                    {miscList?.title && <div styleName="heading">{miscList.title}</div>}
                    <div styleName="gridTwo">
                      {Array.isArray(miscList?.items) &&
                        miscList.items.map((item, idx) => {
                          const { text } = parseSubTitle(item?.SubTitle);
                          return (
                            <div
                              key={`misc-${idx}`}
                              styleName="item"
                              onClick={() => handleClickItem(item, formattedPageType)}
                            >
                              <BQLink
                                styleName="link"
                                href={item?.Link}
                                target={item?.Target}
                                rel={item?.Rel}
                                style={{
                                  '--dynamic-color': isBeeps
                                    ? '#ffffff'
                                    : item.EmbedCode || 'var(--mine-shaft)',
                                }}
                              >
                                {item.Title}
                                {text && <span styleName="tag">{text}</span>}
                              </BQLink>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* BADGE SECTIONS */}
            <div styleName="badgeSection">
              <div styleName="hrLine" />
              <div styleName="badgeContent">
                <div styleName="content">
                  <div styleName="title">{googleBadge?.title}</div>
                  <div styleName="subTitle">{googleBadge?.subTitle}</div>
                </div>
                <div onClick={() => clickPreferredSourceBadge()}>
                  <BQLink href={googleBadge?.link} target={googleBadge?.target || '_self'}>
                    <img
                      src={googleBadge?.circleBadge}
                      alt="Google Badge"
                      height="38px"
                      width="auto"
                    />
                  </BQLink>
                </div>
              </div>
            </div>
          </div>
          {/* <div styleName="appScannerSection" className="desktop-only">
            <div styleName="appTitle">
              <div>{STRINGS?.SCAN_APP_TITLE}</div>
              <div styleName="appSubTitle">{STRINGS?.SCAN_APP_SUB_TITLE}</div>
            </div>
            <SvgIcon
              type="app-download-scanner"
              width="172px"
              height="191px"
              source="app-scanner"
              isSvg={false}
              loading="lazy"
            />
          </div> */}
        </div>
      </div>
    </>
  );
};

export default DrawerMenu;
